import type { ReactNode } from 'react';
import { OverlayScrollArea } from '@odo/shared-ui';

interface TaskScrollColumnProps {
    /** Spacing between the stacked cards, e.g. `gap-4`. */
    gapClassName: string;
    children: ReactNode;
}

// A task's narrow side column: its cards fill the height when they fit and scroll as one when not.
export function TaskScrollColumn({ gapClassName, children }: TaskScrollColumnProps) {
    return (
        <OverlayScrollArea
            className="flex-[3] min-w-0 min-h-0"
            innerClassName={`min-h-full flex flex-col ${gapClassName}`}
            trackInsetPx={8}
        >
            {children}
        </OverlayScrollArea>
    );
}

interface TaskColumnFillProps {
    /** Floor the card keeps on short screens, e.g. `min-h-[200px]`; the column scrolls past it. */
    minHeightClassName: string;
    children: ReactNode;
}

// Takes the column's spare height for one card; the 0px basis (not flex-1's 0%) stops it growing
// to its content, so the card scrolls inside instead.
export function TaskColumnFill({ minHeightClassName, children }: TaskColumnFillProps) {
    return (
        <div
            className={`grow basis-0 ${minHeightClassName} flex flex-col [&>*]:flex-1 [&>*]:min-h-0`}
        >
            {children}
        </div>
    );
}
